export const INITIALIZE_APP = "INITIALIZE_APP";

export const UPDATE_GLOBALS = "UPDATE_GLOBALS";
